import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Icon, Button } from '@ers/ui';
import { useLocation } from '@ers/hooks';
import { MenuItem, MenuItemTypes } from '@ers/data';

const ErrorLayout = ({ children, icon }) => {
    const { navigate } = useLocation();
    const handleClick = useCallback(() => navigate(MenuItem.get(MenuItemTypes.Home).url()));
    return (
        <div className="error-layout">
            <Icon name={icon} big />
            <div className="error-layout__text with-margin--top-3">{children}</div>
            <Button.Secondary onClick={handleClick}>Przejdź do strony głównej</Button.Secondary>
        </div>
    );
};
ErrorLayout.propTypes = {
    icon: PropTypes.string.isRequired
};

export default ErrorLayout;
